/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions, FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions';
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsStorePage.js.map